import styled from "styled-components";

export const StyledConfigCollaboratorModal = styled.div`
  & .form-container {
    min-height: 350px;

    & > section {
      margin-top: 20px;
      width: 270px;
    }
  }

  & .toggle-container {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
  }
`;
